<template>
  <div
    v-if="props.note"
    class="appointment-note"
  >
    <div class="appointment-note__date">
      {{ props.note.created_at }}
    </div>
    <div
      class="appointment-note__description"
    >
      <template v-if="props.note.customer_note">
        <p>
          {{ $t('appointments.modify.notes.customer_note') }}
        </p>
      </template>
      <div
        class="appointment-note__contenet"
        :class="{
          'appointment-note__content--customer': props.note.customer_note
        }"
      >
        {{ props.note.description }}
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  note: {
    type: Object,
    default() {
      return {}
    }
  }
})
</script>

<style scoped src="./AppointmentNote.css"></style>
